import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import Grid from '../../Utils/GridVDocumento';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';
import TablaDetalle from './AnticipoDetalle';
import TablaVerDetalle from './AnticipoDetalleVer';
import classNames from 'classnames';

import {
    renderDayPickerB,
    renderField,
    renderNumber,
    SelectField,
    AsyncSelectField,
    renderCurrencyFloat,
    renderCurrencyFloatTC,
    AsyncSelectFieldIn

} from "../../Utils/renderField/renderField";


function AnticipoClienteForm(props) {
    const { crear, lectura, editar, eliminarLineaAbonoNuevo,
        leerAnticipos, doc, listarClientes, list_ant, monedas,
        loader, bloqueo, detalleDoc, 
        fechaFinal, list_doc, periodoD, agregarLinea, detalleDocN,
        tipoCambio } = props;

    
    const estilo = {
        overflow: "auto",
        height: "200px",

    };

    const handleOnChange = value => {
        if (editar){
            leerAnticipos(value.value, fechaFinal, lectura.moneda);
        }else{
            leerAnticipos(value.value, fechaFinal, moneda);
        }
        
    };

    const [tipoCambioD, setTipoCambioD] = useState(1.000000);
    const [moneda, setMoneda] = useState('');

    const handleChangeMoneda = (e) => {
        setMoneda(e.target.value);
        localStorage.setItem('monedaAntCli', e.target.value);
    };
    
    return (
        <div>
            <div className='row mb-2'>
                <div className='col-3'>
                    <Field
                        disabled={bloqueo}
                        name="fecha_registro"
                        component={renderDayPickerB}
                        msj="Fecha Registro"
                    />
                </div>
                {((crear === false && editar == false)) &&
                    <div className='col-3'>
                        <Field
                            name="serie"
                            placeholder="Serie"
                            className="form-control"
                            component={renderField}
                            disabled={true}
                            msj="Serie"
                        />
                    </div>
                }
                {((crear === false && editar == false)) &&
                    <div className='col-3'>
                        <Field
                            name="numero"
                            placeholder="Numero"
                            className="form-control"
                            component={renderNumber}
                            disabled={true}
                            msj="Número"
                        />
                    </div>
                }
                {(crear === true) &&
                    <div className='col-3'>
                        <div className="form-floating">
                            <select className="form-select" id="tipo" name="tipo"
                                value={editar === true ? lectura.concepto : moneda} onChange={handleChangeMoneda}>
                                <option selected>Seleccionar...</option>
                                {monedas.map(
                                    tip => <option key={tip.value} value={tip.value}
                                    >{tip.label}
                                    </option>)
                                }
                            </select>
                            <label className='form-label' htmlFor="mes">Moneda</label>
                        </div>
                    </div>
                }
                {(crear === true) && (
                    <div className='col-3'>
                        <div className="form-floating">
                            <NumberFormat
                                className={classNames('form-control')}
                                decimalScale={6}
                                fixedDecimalScale
                                placeholder="Tipo de cambio"
                                value={tipoCambioD}
                                thousandSeparator
                                onValueChange={(values) => {
                                    setTipoCambioD(values.value)
                                    localStorage.setItem('TC_antCli', tipoCambioD)
                                }}
                            />
                            <label className='form-label' htmlFor="tipo">
                                Tipo de cambio
                            </label>
                        </div>
                    </div>
                )}
                {(crear === true) && (
                    <div className='col-3 mt-2'>
                        <button
                            className='btn mr-2 mb-3 btn-secondary'
                            onClick={() => {
                                let tc = tipoCambio(periodoD);
                                if (tc === undefined) {
                                    setTipoCambioD('1.000000');
                                } else {
                                    tc.then(d => {
                                        if (d === undefined) {
                                            setTipoCambioD('1.000000');
                                        } else {
                                            setTipoCambioD(d);
                                            localStorage.setItem('TC_antCli', d)

                                        }
                                    });
                                }
                            }}
                        >
                            Buscar tipo de cambio
                        </button>
                    </div>
                )}
            </div>
            <div className='row mb-2'>
                {(crear === false && editar === false) &&
                    <div className='col-3'>
                        <div className="form-floating">
                            <Field
                                name="moneda"
                                options={monedas}
                                crear={crear}
                                dato={crear === true ? 0 : lectura.moneda}
                                component={SelectField}
                                className="form-select"
                                disabled={bloqueo}
                                msj="Moneda"
                                />
                        </div>
                    </div>
                }
                {crear === false && editar == false &&
                    <div className='col-3'>
                        <Field
                            name="tipo_cambio"
                            placeholder="Tipo de cambio"
                            className="form-control"
                            component={renderCurrencyFloatTC}
                            disabled={bloqueo}
                            msj="Tipo de cambio"
                        />
                    </div>
                }
            </div>
            {((crear === false && editar == false)) &&
                <div className='mb-2'>
                    <Field
                        name="clienteN"
                        placeholder="Cliente"
                        className="form-control"
                        component={renderField}
                        disabled={true}
                        msj="Cliente"
                    />
                </div>
            }
            {(crear === true) &&
                <div className='mb-2'>
                    <Field
                        name="cliente_documento"
                        placeholder="Cliente..."
                        className="form-control-find"
                        component={AsyncSelectField}
                        loadOptions={listarClientes}
                        onChange={handleOnChange}
                        msj="Cliente"
                    />
                </div>
            }
            {(crear === true) &&
                <div className='row'>
                    <div className='col-6 mb-2'>
                        <Field
                            name="documento"
                            placeholder="Documento..."
                            className="form-control-find"
                            loadOptions={list_doc}
                            component={AsyncSelectFieldIn}
                            msj="Documento"
                        />
                    </div>
                </div>
            }
            <div className='mb-2'>
                <Field
                    name="descripcion"
                    placeholder="Descripcion"
                    component={renderField}
                    className="form-control"
                    disabled={bloqueo}
                    msj="Descripción"
                />
            </div>
            {(crear === true || editar === true) &&
                <div>
                    <h5 className="p-2 bg-secondary title mt-1">Anticipos</h5>
                    <div style={estilo}>
                        <Grid
                            hover
                            striped
                            data={doc}
                            loading={loader}
                            headerStyle={{ background: 'black' }}

                        >
                            <TableHeaderColumn
                                isKey
                                dataField="fecha"
                                dataSort
                                dataFormat={(cell, row) => {
                                    return moment(cell).format("DD/MM/YYYY");
                                }}
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Fecha
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="numero"
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Documento
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="tipoDoc"
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Tipo
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="clienteN"
                                width="350"
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Cliente
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="total"
                                headerAlign="center"
                                dataAlign='right'
                                dataFormat={(cell, row) => {
                                    if (parseFloat(cell) === 0.00) {
                                        return ''
                                    } else {
                                        return new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(cell);
                                    }
                                }}
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Total
                            </TableHeaderColumn>
                        </Grid>
                    </div>
                    <br/>
                    <div className='row mb-2'>
                        <div className='col-6 mt-1'>
                            <Field
                                name="anticipo"
                                placeholder="Documento..."
                                className="form-control-find"
                                loadOptions={list_ant}
                                component={AsyncSelectFieldIn}
                                msj="Anticipo"
                            />
                        </div>
                        <div className='col-3 mt-1'>
                            <div className="form-floating">
                                <Field
                                    name="abono"
                                    placeholder="Abono"
                                    className="form-control"
                                    component={renderCurrencyFloat}
                                    disabled={false}
                                    msj="Abono"
                                />
                            </div>
                        </div>
                    </div>
                    {(crear === true) &&
                        <Contenido>
                            <button
                                className='btn mr-2 mb-3 btn-primary'
                                onClick={() => agregarLinea(periodoD)}
                            >
                                Agregar documento
                            </button>
                        </Contenido>
                    }
                    {(crear === true) &&
                        <div>
                            <h5 className="p-2 bg-secondary title mt-1">Documentos agregados</h5>
                            <div style={estilo}>
                                <TablaDetalle
                                    detalle={detalleDocN}
                                    eliminarDocumento={eliminarLineaAbonoNuevo}
                                />
                            </div>
                        </div>
                    }
                </div>
            }
            {crear === false && editar === false &&
                <div>
                    <h5 className="p-2 bg-secondary title mt-1">Documentos agregados</h5>
                    <div style={estilo}>
                        <TablaVerDetalle
                            detalle={detalleDoc}
                        />
                    </div>
                </div>
            }
        </div>

    );
}

AnticipoClienteForm.propTypes = {
    registroAbono: PropTypes.func,
    crear: PropTypes.bool,
    editar: PropTypes.bool,
    lectura: PropTypes.object,
    listarClientes: PropTypes.object,
    leerDocumentos: PropTypes.func,
    doc: PropTypes.object,
    loader: PropTypes.bool,
    bloqueo: PropTypes.bool,
    detalleDoc: PropTypes.object,
    eliminarDocumento: PropTypes.func,
    cuentasBan: PropTypes.object,
    monedas: PropTypes.array,
    fechaInicio: PropTypes.string,
    fechaFinal: PropTypes.string,
    list_doc: PropTypes.object,
    periodoD: PropTypes.object,
    agregarLinea: PropTypes.func,
    eliminarLineaAbonoNuevo: PropTypes.func,
    nuevaLineaDocumento: PropTypes.func,
    detalleDocN: PropTypes.object
};

export default reduxForm({
    form: 'FormAnticipoCliente',
})(AnticipoClienteForm);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;